import { useTranslation } from 'next-i18next';

import { HomeWidgetEmptyState } from '@/modules/home';
import { getApprovalsTableColumn } from '@/modules/home/components/PageContent/Approvals/logic';
import { IHome } from '@/modules/home/types';
import ApprovalPathActions from '@/modules/settings/approvals/components/Header/ApprovalPathActions';
import { Button, Table } from '@/shared/components/atoms';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';
import { InfiniteScrollProps } from '@/shared/lib/react-infinite-scroller';

import Clipboard from '~/images/shared/Clipboard.svg';

const ApprovalsTable: React.FC<{
  data: IHome.IApprovalSchema[] | undefined;
  infiniteScrollProps: InfiniteScrollProps;
}> = ({ data, infiniteScrollProps }) => {
  const { t } = useTranslation();

  return data?.length ? (
    <Table<IHome.IApprovalSchema>
      data={data}
      columns={getApprovalsTableColumn(t)}
      selection={false}
      pagination={false}
      headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10'
      headContainerClassName='!bg-background-neutral-99'
      rowContainerClassName='!bg-background-transparent last-of-type:border-b-0 border-neutralVariant-90 border-b-xs'
      tableWrapperClassName='max-h-343'
      tableClassName='!border-collapse'
      headerClassName='!z-[1]'
      infiniteScrollProps={infiniteScrollProps}
    />
  ) : !data?.length ? (
    <HomeWidgetEmptyState
      icon={<Clipboard width='48' height='48' />}
      title={t('No Approvals!')}
      message={
        <TippyTooltip
          trigger='click'
          placement='bottom'
          content={<ApprovalPathActions />}
        >
          <Button
            size='none'
            variant='text'
            className='mt-16 flex h-40 items-center justify-center border-xs border-outline-default px-16'
          >
            {t('create-approval-path')}
          </Button>
        </TippyTooltip>
      }
    />
  ) : null;
};

export default ApprovalsTable;
